module.exports = __webpack_public_path__ + "static/farma2go-MONEI-ac6abd9efddcd0688bc2df13c1c6b441.png";